class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', event => { if (event.code === 'Escape') this.close(); });
    this.addEventListener('click', event => { if (event.target.id === 'CartDrawer-Overlay') this.close(); });
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const link = document.querySelector('#cart-icon-bubble');
    if (!link) return;
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'CartDrawer');
    link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', event => { event.preventDefault(); this.open(link); });
    link.addEventListener('keydown', event => {
      if (event.code === 'Space') { event.preventDefault(); this.open(link); }
    });
  }
  connectedCallback() {
    if (this.lifecycle) return;
    this.lifecycle = new AbortController();
    this.addEventListener('click', event => {
      if (event.target.closest('#CartDrawer-Checkout')) this.checkoutDeparture = true;
    }, {signal: this.lifecycle.signal});
    window.addEventListener('pageshow', event => {
      if (!event.persisted || !this.checkoutDeparture) return;
      this.checkoutDeparture = false;
      window.location.reload();
    }, {signal: this.lifecycle.signal});
  }
  disconnectedCallback() {
    this.lifecycle?.abort();
    this.lifecycle = null;
    this.stopMotion();
  }
  stopMotion() {
    this.effects?.forEach(effect => effect.cancel());
    this.effects = [];
  }
  open(triggeredBy) {
    if (triggeredBy && this.classList.contains('active') && !this.closing) {
      this.querySelector('.drawer__close')?.focus({preventScroll: true});
      return;
    }
    document.querySelector('details-modal.hs-search details[open]')?.closest('details-modal').close(false);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const wasOpen = this.classList.contains('active');
    const panel = this.querySelector('.drawer__inner');
    const from = wasOpen ? getComputedStyle(panel).transform : 'translateX(100%)';
    const overlay = this.querySelector('#CartDrawer-Overlay');
    const overlayFrom = wasOpen && overlay ? getComputedStyle(overlay).opacity : 0;
    this.transition = (this.transition || 0) + 1;
    const wasClosing = this.closing;
    this.stopMotion();
    this.closing = false;
    document.querySelector('hs-navigation')?.close(true, false);
    this.classList.add('animate', 'active');
    document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    if (!wasOpen || wasClosing) {
      this.effects = window.HardstoneMotion?.panel(panel, overlay, {phase: 'enter', side: 'right', from, overlayFrom}) || [];
    }
    requestAnimationFrame(() => {
      if (this.classList.contains('active') && !this.closing) trapFocus(this.querySelector('.drawer__inner'), this.querySelector('.drawer__close'));
    });
  }
  async close(immediate = false, restore = true) {
    if (!this.classList.contains('active') || this.closing && !immediate) return;
    const panel = this.querySelector('.drawer__inner');
    const from = getComputedStyle(panel).transform;
    const overlay = this.querySelector('#CartDrawer-Overlay');
    const overlayFrom = overlay ? getComputedStyle(overlay).opacity : 1;
    const token = this.transition = (this.transition || 0) + 1;
    this.stopMotion();
    this.closing = true;
    if (!immediate) {
      this.effects = window.HardstoneMotion?.panel(panel, overlay, {phase: 'exit', side: 'right', from, overlayFrom}) || [];
      await Promise.allSettled(this.effects.map(effect => effect.finished));
    }
    if (token !== this.transition) return;
    this.classList.remove('active');
    this.stopMotion();
    this.closing = false;
    document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'false');
    removeTrapFocus();
    if (!document.querySelector('.hs-nav-disclosure[open]')) document.body.classList.remove('overflow-hidden');
    if (restore) this.activeElement?.focus({preventScroll: true});
  }
  renderContents(parsedState) {
    const fragments = this.getSectionsToRender().map(section => {
      const html = parsedState.sections?.[section.id];
      if (typeof html !== 'string') throw new Error('Cart section is unavailable');
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      const target = section.selector ? this.querySelector(section.selector) : document.getElementById(section.id);
      if (!source || !target) throw new Error('Cart section is incomplete');
      return {source, target};
    });
    fragments.forEach(({source, target}) => { target.innerHTML = source.innerHTML; });
    this.classList.toggle('is-empty', Boolean(this.querySelector('cart-drawer-items.is-empty')));
    this.productId = parsedState.id;
    this.open();
  }
  getSectionsToRender() {
    return [{id: 'cart-drawer', selector: '#CartDrawer'}, {id: 'cart-icon-bubble'}];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) { this.activeElement = element; }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner'},
      {id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'}
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
